export default "__VITE_ASSET__CIiUXsPw__"